import React from "react";
import Item from "./item";
import styles from "./index.module.less";
import { movie, article } from "@Api";

const { fetchV3Articles } = article;
const { fetchHotColumnNav } = movie;

class ArticleKindsMovies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      left: true,
      right: false,
      categoryIndex: 0,
      navList: [],
      data: [],
    };
  }
  kindsRef = React.createRef();
  componentDidMount() {
    this.getNav();
    setTimeout(() => {
      this.kindsRef.current && this.kindsRef.current.addEventListener("scroll", (e) => this.onScroll(e));
    }, 800);
  }

  componentWillUnmount() {
    this.kindsRef.current && this.kindsRef.current.removeEventListener("scroll", (e) => this.onScroll(e));
  }

  async getNav() {
    const { kinds } = this.props;
    let idsList = kinds.map((item) => {
      return item.kind_id;
    });
    const res = await fetchHotColumnNav({ kindIds: idsList.join(",") });

    if (res && res.status === 12000) {
      this.setState(
        {
          navList: [{ title: "最新", total: 0, value: "", slug: "" }, ...res.data.movieNavs],
        },
        () => {
          this.getList();
        },
      );
    }
  }

  async getList() {
    const { kinds } = this.props;
    const { categoryIndex, navList } = this.state;
    let idsList = kinds.map((item) => {
      return item.kind_id;
    });
    const res = await fetchV3Articles({
      type: "3",
      limit: 20,
      kindIds: idsList.join(","),
      filterIds: window.movie_id || 0,
      contentType2: navList[categoryIndex].value,
    });

    if (res && res.status === 12000) {
      this.setState({
        data: res.data.list,
      });
    }
  }

  scrollTo = (scrollValue) => {
    if (this.kindsRef.current) {
      let scrollLeft = this.kindsRef.current.scrollLeft;
      this.kindsRef.current.scrollTo(scrollLeft + scrollValue, 0);
    }
  };

  onScroll = (e) => {
    if (this.kindsRef.current && e) {
      const scrollLenght = this.kindsRef.current.scrollWidth - 850;
      let scrollLeft = e.currentTarget.scrollLeft;
      this.setState({
        right: scrollLeft === scrollLenght,
        left: scrollLeft === 0,
      });
    }
  };

  render() {
    const { category, kinds } = this.props;
    const { left, right, categoryIndex, navList, data } = this.state;

    if (data.length === 0 || kinds.length === 0) {
      return null;
    }

    return (
      <section className={styles["ArticleKindsMovies"]}>
        <div className='flex items-center justify-between flex-wrap mb-10'>
          <h2>相關&競爭車款影音</h2>

          {Array.isArray(navList) && navList.length > 0 && (
            <div className='flex flex-wrap'>
              {navList.map((item, index) => (
                <p
                  key={index}
                  className={`py-6 px-10 mr-14 text-14 font-bold leading-20 rounded-16 cursor-pointer mb-10 ${
                    categoryIndex === index ? "text-[#fff] bg-[#3264FF]" : "bg-[#EAEFFF] text-[#333]"
                  }`}
                  onClick={() => {
                    this.setState(
                      {
                        categoryIndex: index,
                      },
                      () => {
                        this.kindsRef.current.scrollTo(0, 0);
                        this.getList();
                      },
                    );
                  }}
                >
                  {item.title}
                </p>
              ))}
            </div>
          )}
        </div>
        <div className={styles["content"]}>
          <div className={styles["brand-scroll"]} ref={this.kindsRef}>
            {!right && data.length > 3 && <i className={styles["right-icon"]} onClick={() => this.scrollTo(980)} />}
            {!left && <i className={styles["left-icon"]} onClick={() => this.scrollTo(-980)} />}
            {data.map((v, i) => (
              <Item data={v} key={i} category={category} />
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default ArticleKindsMovies;
